export const ANNOUNCEMENT_VARIANTS = [
  {
    value: "default",
    label: "Announcement",
    icon: "mdi-bullhorn",
    gradientClass: "announcement-card--default",
    buttonColor: "white",
    fallbackCtaLabel: "Learn more",
  },
  {
    value: "youtube",
    label: "YouTube Highlight",
    icon: "mdi-youtube",
    gradientClass: "announcement-card--youtube",
    buttonColor: "red",
    fallbackCtaLabel: "Watch now",
  },
  {
    value: "whatsapp",
    label: "WhatsApp Invite",
    icon: "mdi-whatsapp",
    gradientClass: "announcement-card--whatsapp",
    buttonColor: "white",
    fallbackCtaLabel: "Open link",
  },
  {
    value: "video-of-week",
    label: "Video of the Week",
    icon: "mdi-play-circle",
    gradientClass: "announcement-card--video-of-week",
    buttonColor: "blue-lighten-3",
    fallbackCtaLabel: "Watch now",
  },
];

export const ANNOUNCEMENT_VARIANT_MAP = ANNOUNCEMENT_VARIANTS.reduce(
  (acc, variant) => {
    acc[variant.value] = variant;
    return acc;
  },
  {},
);

export const ANNOUNCEMENT_LAYOUTS = [
  {
    value: "full",
    label: "Full Width (1 Per Row)",
    mdCols: 12,
  },
  {
    value: "half",
    label: "Half Width (2 Per Row)",
    mdCols: 6,
  },
  {
    value: "third",
    label: "Third Width (3 Per Row)",
    mdCols: 4,
  },
];

export const ANNOUNCEMENT_LAYOUT_MAP = ANNOUNCEMENT_LAYOUTS.reduce(
  (acc, layout) => {
    acc[layout.value] = layout;
    return acc;
  },
  {},
);

export const ANNOUNCEMENT_LAYOUT_VALUES = ANNOUNCEMENT_LAYOUTS.map(
  (layout) => layout.value,
);

export const normalizeAnnouncementLayout = (layout) =>
  ANNOUNCEMENT_LAYOUT_MAP[layout] ? layout : "full";
